<template>
  <div class="view-item-odonto">
    <b-card class="shadow-sm border-0">
      <h4 class="text-center font-weight-bold text-primary mb-3">
        Ver Item Procedimiento
      </h4>

      <div v-if="detail" class="view-item-body">
        <section class="section-card mb-3">
          <div class="section-title">Información del item</div>
          <b-row>
            <b-col md="4" class="mb-2">
              <p class="label">Código</p>
              <p class="value">{{ detail.codigo || "-" }}</p>
            </b-col>
            <b-col md="4" class="mb-2">
              <p class="label">Especialidad</p>
              <p class="value">
                {{ (detail.especialidad && detail.especialidad.descripcion) || "-" }}
              </p>
            </b-col>
            <b-col md="4" class="mb-2">
              <p class="label">Nombre</p>
              <p class="value">{{ detail.descripcion || "-" }}</p>
            </b-col>
          </b-row>
        </section>

        <section class="section-card mb-3">
          <div class="section-title">Precios</div>
          <b-table-simple small responsive class="mb-0">
            <b-thead>
              <b-tr>
                <b-th>Entidad</b-th>
                <b-th class="text-right">Precio</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="row in priceRows" :key="row.label">
                <b-td>{{ row.label }}</b-td>
                <b-td class="text-right">{{ row.value }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </section>

        <section class="section-card mb-3">
          <div class="section-title">Estados de Cobertura</div>
          <div class="d-flex flex-wrap">
            <div
              v-for="state in coverageStates"
              :key="state.label"
              class="d-flex align-items-center mr-3 mb-2"
            >
              <span
                class="status-dot"
                :class="state.active ? 'bg-success' : 'bg-danger'"
              ></span>
              <span :class="state.active ? 'text-success' : 'text-danger'">
                {{ state.label }}
              </span>
            </div>
          </div>
        </section>

        <section class="section-card">
          <div class="section-title">Establecimientos</div>
          <b-row>
            <b-col md="6" v-for="est in establecimientoList" :key="est.id">
              <div class="d-flex align-items-center mb-2">
                <span class="font-weight-bold mr-2 text-uppercase">{{
                  est.nombre
                }}</span>
                <span :class="est.activo ? 'text-success' : 'text-danger'">
                  <i
                    :class="
                      est.activo ? 'fas fa-check-circle' : 'fas fa-times-circle'
                    "
                    class="mr-1"
                  ></i>
                  {{ est.activo ? "Activo" : "Inactivo" }}
                </span>
              </div>
            </b-col>
            <b-col v-if="establecimientoList.length === 0">
              <span class="text-muted">-</span>
            </b-col>
          </b-row>
        </section>
      </div>

      <div v-else class="text-center text-muted py-3">
        No se encontraron detalles.
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { comprobarPermisos } from "@/shared/helpers";
import {
  BRow,
  BCol,
  BCard,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  props: ["token"],
  data() {
    return {
      detail: null,
      establecimientosList: [],
    };
  },
  async created() {
    comprobarPermisos(this.$route);
    this.establecimientosList = await this.fetchEstablecimientos();
    await this.fetchitemOdontologico(this.token);
  },
  computed: {
    priceRows() {
      if (!this.detail || !this.detail.precioJson) return [];
      const p = this.detail.precioJson;
      return [
        { label: "ISSFA N1", value: this.formatCurrency(p.issfa_n1) },
        { label: "ISSFA N2", value: this.formatCurrency(p.issfa_n2) },
        { label: "IESS N1", value: this.formatCurrency(p.iess_n1) },
        { label: "ISSPOL N1", value: this.formatCurrency(p.isspol_n1) },
        { label: "PARTICULAR", value: this.formatCurrency(p.particular) },
      ];
    },
    coverageStates() {
      if (!this.detail || !this.detail.estadoJson) return [];
      const e = this.detail.estadoJson;
      return [
        { label: "IESS", active: !!e.iess },
        { label: "ISSFA", active: !!e.issfa },
        { label: "ISSPOL", active: !!e.isspol },
        { label: "PARTICULAR", active: !!e.particular },
      ];
    },
    establecimientoList() {
      const ids =
        (this.detail && this.detail.establecimiento
          ? this.detail.establecimiento
          : ""
        )
          .toString()
          .split(",")
          .map((e) => e.trim())
          .filter(Boolean);

      if (!this.establecimientosList || !this.establecimientosList.length) {
        return ids.map((id) => ({ id, nombre: id, activo: true }));
      }

      return this.establecimientosList.map((est) => ({
        id: est.value ? String(est.value) : "",
        nombre: est.text,
        activo: ids.includes(String(est.value)),
      }));
    },
  },
  methods: {
    formatCurrency(value) {
      const numberValue = Number(value || 0);
      return `$${numberValue.toFixed(2)}`;
    },
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        const list = response.data.data.allEstablecimientos.map((item) => ({
          value: item.id,
          text: item.Descripcion,
        }));
        return list;
      } catch (error) {
        console.error("Error cargando establecimientos", error);
        return [];
      }
    },
    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === "object") return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value
            .replace(/'/g, '"')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (err) {
          console.warn("No se pudo parsear JSON flexible", value);
          return {};
        }
      }
    },
    async fetchitemOdontologico(token) {
      const query = `
        query GetitemOdontologico($tokenproc: String!) {
                allOdonto(tokenproc: $tokenproc) {
                    total
                    status
                    message
                    itemOdontologico{
                        id
                        token
                        descripcion
                        establecimiento
                      	especialidad {
                          id
                          descripcion
                        }
                        codigo
                        estado
                        precio
                        precioJson
                        estadoJson
                    }
                   
                }
            }
        `;

      const variables = { tokenproc: token };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });
        if (response.data.data.allOdonto.status === "Success") {
          const item = response.data.data.allOdonto.itemOdontologico?.[0];
          if (!item) return;
          item.precioJson = this.parseFlexibleJson(item.precioJson);
          item.estadoJson = this.parseFlexibleJson(item.estadoJson);
          this.detail = item;
        } else {
          console.error(
            "Error al obtener la itemOdontologico:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
  },
};
</script>

<style scoped>
.view-item-odonto {
  margin-bottom: 10px;
}

.section-card {
  background: #f8f9fb;
  border-radius: 10px;
  padding: 15px;
}

.section-title {
  font-weight: 700;
  color: #4a4a68;
  margin-bottom: 10px;
}

.label {
  margin-bottom: 0;
  color: #6c757d;
  font-weight: 600;
  font-size: 0.85rem;
}

.value {
  margin-bottom: 0;
  color: #343a40;
  font-weight: 700;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.estab-badge {
  margin-right: 8px;
  margin-bottom: 8px;
  font-weight: 600;
  color: #28a745;
  background: #e8f7ed;
}
</style>
